import React from 'react';
import LoadingComponent from '../loading-component';
import TranslatedCopy from '../../../intl/translated-copy';

const RefundLoader = () => {
  return (
    <div className='RefundLoader'>
      <div className='RefundLoader-textContainer'>
        <TranslatedCopy
          className='RefundLoader-textContainer--title'
          copyID='MYB_THIS_WILL_TAKE_A_FEW_MOMENTS'
        />
        <TranslatedCopy
          className='RefundLoader-textContainer--header'
          copyID='MYB_PROCESSING_YOUR_REFUND_FINAL'
        />
      </div>
      <LoadingComponent className='RefundLoader-loader' refunds={ true } />
    </div>
  );
};

export default RefundLoader;